import axios from 'axios'
import { i18n } from '../main'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    config.headers.lang = i18n.locale.toUpperCase()
    return config
  },
  (error) => Promise.reject(error),
)

export default {
    sendInquiryMail(body) {
      return apiClient.post('/quick/contact/send/inquiry', body)
    }
}